import * as yup from 'yup';
const validateConfirmResetPasswordForm = yup.object({
  code: yup.number().required('Code is a required field'),
  newPassword: yup
    .string()
    .required('Password is a required field')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{12,}$/,
      'Must contain 12 characters or more, one uppercase, one lowercase, one number and one special case character'
    ),
  newPassword2: yup
    .string()
    .required('Password is a required field')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{12,}$/,
      'Must contain 12 characters or more, one uppercase, one lowercase, one number and one special case character'
    )
    .oneOf([yup.ref('newPassword'), null], 'Password is not same')
});

export default validateConfirmResetPasswordForm;
